// extracted by mini-css-extract-plugin
export default {"btnCustom":"Button_btnCustom__qo-QB"};